module.exports = __webpack_public_path__ + "cc33fe268eddcfc8238ff2b9925b6f4c.svg";